import styled from "styled-components";
export * from "../components/expenditure/style";
export * from "../components/manualPoint/style";

export const PopupHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 40px;
  box-sizing: border-box;

  > .box {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .back {
    cursor: pointer;
  }

  .button {
    width: 82px;
    height: 28px;
    border-radius: 6.11px;
    background: #d91818;
    color: #fff;
    line-height: 28px;
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }
`;

export const MainWrapper = styled.div`
  padding: 0 40px;
  font-family: Pretendard;
  height: auto;
`;

export const ButtonGroup = styled.div`
  display: flex;
  width: calc(100% - 32px);
  gap: 8px;
  position: absolute;
  bottom: 20px;

  > .button {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    line-height: 48px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    color: #6436e7;

    &.purple {
      color: #fff;
      background: #7f25fb;
    }
  }
`;

export const SearchBox = styled.div`
  display: flex;
  width: 100%;
  height: 35px;
  border-radius: 15px;
  background-color: #fff;
  padding: 0 15px;
  box-sizing: border-box;
  background: #e5e5e5;

  > .member {
    height: 25px;
    padding: 0px 10px;
    gap: 10px;
    border-radius: 9.78px;
    background: #7f25fb;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 500;
    line-height: 25px;
    position: absolute;
    margin-top: 4px;
    display: flex;
    gap: 10px;
    align-items: center;

    > img {
      width: 7px;
      height: 7px;
      cursor: pointer;
    }
  }

  > input {
    flex: 1;
    border: none;
    outline: none;
    background: #e5e5e5;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 600;
  }

  input::placeholder {
    color: #b7b7b7;
  }

  .searchIcon {
    width: 40px;
    height: 40px;
    cursor: pointer;
    text-align: right;
    line-height: 40px;
  }
`;
